export default "__VITE_ASSET__BMBErGdM__"